/* tslint:disable:no-trailing-whitespace import-spacing */

import {
  Routes,
  RouterModule
}                                          from '@angular/router';

import { NgModule                     }    from '@angular/core';

import { PanoramaComponent            }    from './screens/panorama/panorama.component';
import { MyProjectsComponent          }    from './screens/my-projects/my.projects.component';
import { MyOrganizationsComponent     }    from './screens/my-organizations/my.organizations.component';
import { ProjectDetailsComponent      }    from './screens/project/project.details.component';
import { OrganizationDetailsComponent }    from './screens/organization/organization.details.component';
import { HelpComponent                }    from './screens/help/help.component';
import { OverwatchComponent           }    from './screens/overwatch/overwatch.component';
import { LoginComponent               }    from './screens/login/login.component';
import { LogoutComponent              }    from './components/logout.component';
import { RegisterComponent            }    from './screens/register/register.component';
import { PrivacyComponent             }    from './screens/privacy/privacy.component';
import { UserListComponent            }    from './screens/administration/user.list.component';
import { SubdivisionsListComponent    }    from './screens/administration/subdivisions.list.component';
import { OrganizationsListComponent   }    from './screens/administration/organizations.list.component';
import { ProjectsListComponent        }    from './screens/administration/projects.list.component';
import { SyncJobsComponent            }    from './screens/administration/sync.jobs.component';
import { ProfileComponent             }    from './screens/profile/profile.component';
import { UserProfileComponent         }    from './screens/user/user.profile.component';
import { AdminComponent               }    from './screens/administration/admin.component';
import { UserDetailComponent          }    from './screens/administration/user.detail.component';
import { PendingUsersComponent        }    from './screens/administration/pending.users.component';
import { ApproveUserComponent         }    from './screens/administration/approve.user.component';
import { NewUserComponent             }    from './screens/administration/new.user.component';
import { LoggedInGuard                }    from './guards/logged.in.guard';

/* define the URI path to view mapping ... */

const appRoutes: Routes = [
  {
    path: 'overwatch',
    component: OverwatchComponent,
    canActivate: [LoggedInGuard],

    data: {
      reuseComponent: true
    }
  },
  { path: 'panorama',                         component: PanoramaComponent,            canActivate: [LoggedInGuard]},
  { path: 'my-projects',                      component: MyProjectsComponent,          canActivate: [LoggedInGuard]},
  { path: 'my-organizations',                 component: MyOrganizationsComponent,     canActivate: [LoggedInGuard]},
  { path: 'help',                             component: HelpComponent,                canActivate: [LoggedInGuard]},
  { path: 'profile',                          component: ProfileComponent,             canActivate: [LoggedInGuard]},
  { path: 'users/:id',                        component: UserProfileComponent,         canActivate: [LoggedInGuard]},
  { path: 'project/:key',                     component: ProjectDetailsComponent,      canActivate: [LoggedInGuard]},
  { path: 'organization/:key',                component: OrganizationDetailsComponent, canActivate: [LoggedInGuard]},
  { path: 'administration',                   component: AdminComponent,               canActivate: [LoggedInGuard]},
  { path: 'administration/users/pending',     component: PendingUsersComponent,        canActivate: [LoggedInGuard]},
  { path: 'administration/users/approve/:id', component: ApproveUserComponent,         canActivate: [LoggedInGuard]},
  { path: 'administration/users/new',         component: NewUserComponent,             canActivate: [LoggedInGuard]},
  { path: 'administration/users/detail/:id',  component: UserDetailComponent,          canActivate: [LoggedInGuard]},
  { path: 'administration/users',             component: UserListComponent,            canActivate: [LoggedInGuard]},
  { path: 'administration/subdivisions',      component: SubdivisionsListComponent,    canActivate: [LoggedInGuard]},
  { path: 'administration/organizations',     component: OrganizationsListComponent,   canActivate: [LoggedInGuard]},
  { path: 'administration/projects',          component: ProjectsListComponent,        canActivate: [LoggedInGuard]},
  { path: 'administration/sync',              component: SyncJobsComponent,            canActivate: [LoggedInGuard]},
  { path: 'privacy',                          component: PrivacyComponent      },
  { path: 'register',                         component: RegisterComponent     },
  { path: 'login',                            component: LoginComponent        },
  { path: 'logout',                           component: LogoutComponent       },

  /* otherwise, redirect to home */

  { path: '**',             redirectTo: 'overwatch'               }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      {
        enableTracing: true,
        paramsInheritanceStrategy: 'always'
      }
    )
  ],
  exports: [ RouterModule ]
})

export class AppRouting { }
